<h3 mat-dialog-title>Import codes</h3>
<form (ngSubmit)="onSubmit()" [formGroup]="form" class="vertical-form">
  <div mat-dialog-content class="content">
    <mat-form-field>
      <mat-label>Product SKUs</mat-label>
      <input type="text" matInput formControlName="productSkuId"
        [matAutocomplete]="auto">
      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn.bind(this)">
        @for (option of filteredOptions | async; track option) {
          <mat-option [value]="option">
            {{option.name}}
          </mat-option>
        }
      </mat-autocomplete>
      @if (form.controls.productSkuId.invalid) {
        <mat-error>Please choose a product SKU</mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Number of characters</mat-label>
      <input type="number" matInput placeholder="" formControlName="numberOfCharacters" [readonly]="true">
    </mat-form-field>

    <mat-form-field>
      <mat-label>Exported format (Mask)</mat-label>
      <input type="text" required matInput placeholder="" formControlName="format"
        (keyup)="onFormatKeyUpEvent($event)">
      @if (form.controls.format.invalid) {
        <mat-error>Please enter a valid format. Format must be contains
        "*"</mat-error>
      }
    </mat-form-field>

    @if (!isLoading) {
      <div class="file-upload-area"
         (click)="csvFileForImport.click()"
         (dragover)="onDragOver($event)"
         (dragleave)="onDragLeave($event)"
         (drop)="onDrop($event)"
         [class.drag-over]="isDragOver"
         [class.button-required]="form.controls.fileToUpload.invalid">
          <div class="upload-content">
            <mat-icon>cloud_upload</mat-icon>
            <p>Drop files here or click to upload</p>
          </div>
      </div>
    }
    <input hidden type="file" (change)="importFromCsv($event)" id="csvFileForImport" #csvFileForImport>
  </div>

  <div mat-dialog-actions class="gap-8">
    <lib-button type="button" (click)="onClose()">Close</lib-button>
    <lib-button variant="raised" color="primary" (click)="onSubmit()" [disabled]="!form.valid">Start Process</lib-button>
  </div>
</form>
<lib-loading-overlay [isLoading]="isLoading" />